export const WEBSOCKET_NOTIFICATION_CONTAINER_ID = 'websocket-notifications';
